export const countryOptions = [
	{ label: 'United States', value: 'US' },
	{ label: 'Australia', value: 'AU' },
	{ label: 'Austria', value: 'AT' },
	{ label: 'Belgium', value: 'BE' },
	{ label: 'Bulgaria', value: 'BG' },
	{ label: 'Canada', value: 'CA' },
	{ label: 'China', value: 'CN' },
	{ label: 'Costa Rica', value: 'CR' },
	{ label: 'Czech Republic', value: 'CZ' },
	{ label: 'Denmark', value: 'DK' },
	{ label: 'Estonia', value: 'EE' },
	{ label: 'Finland', value: 'FI' },
	{ label: 'France', value: 'FR' },
	{ label: 'Germany', value: 'DE' },
	{ label: 'Hong Kong', value: 'HK' },
	{ label: 'India', value: 'IN' },
	{ label: 'Ireland', value: 'IE' },
	{ label: 'Israel', value: 'IL' },
	{ label: 'Italy', value: 'IT' },
	{ label: 'Japan', value: 'JP' },
	{ label: 'Liechtenstein', value: 'LI' },
	{ label: 'Lithuania', value: 'LT' },
	{ label: 'Luxembourg', value: 'LU' },
	{ label: 'Mexico', value: 'MX' },
	{ label: 'Netherlands', value: 'NL' },
	{ label: 'Norway', value: 'NO' },
	{ label: 'Philippines', value: 'PH' },
	{ label: 'Poland', value: 'PL' },
	{ label: 'Portugal', value: 'PT' },
	{ label: 'Romania', value: 'RO' },
	{ label: 'Singapore', value: 'SG' },
	{ label: 'South Korea', value: 'KR' },
	{ label: 'Spain', value: 'ES' },
	{ label: 'Sweden', value: 'SE' },
	{ label: 'Switzerland', value: 'CH' },
	{ label: 'Taiwan', value: 'TW' },
	{ label: 'Turkey', value: 'TR' },
	{ label: 'United Kingdom', value: 'GB' },
];

export const budgetRanges = [
	{ label: '$25', value: 25, minBudget: 19, maxBudget: 25 },
	{ label: '$50', value: 50, minBudget: 35, maxBudget: 50 },
	{ label: '$75', value: 75, minBudget: 51, maxBudget: 75 },
	{ label: '$100', value: 100, minBudget: 76, maxBudget: 100 },
	{ label: '$125', value: 125, minBudget: 89, maxBudget: 125 },
	{ label: '$150', value: 150, minBudget: 101, maxBudget: 150 },
	{ label: '$200', value: 200, minBudget: 151, maxBudget: 200 },
	{ label: '$250', value: 250, minBudget: 200, maxBudget: 250 },
	{ label: '$300', value: 300, minBudget: 250, maxBudget: 300 },
	{ label: '$350', value: 350, minBudget: 250, maxBudget: 350 },
	{ label: '$400', value: 400, minBudget: 300, maxBudget: 400 },
	{ label: '$500', value: 500, minBudget: 400, maxBudget: 500 },
	{ label: '$600', value: 600, minBudget: 500, maxBudget: 600 },
	{ label: '$750', value: 750, minBudget: 650, maxBudget: 750 },
	{ label: '$800', value: 800, minBudget: 700, maxBudget: 800 },
	{ label: '$900', value: 900, minBudget: 800, maxBudget: 900 },
	{ label: '$1,000', value: 1000, minBudget: 900, maxBudget: 1000 },
	{ label: '$1,250', value: 1250, minBudget: 1000, maxBudget: 1250 },
	{ label: '$1,500', value: 1500, minBudget: 1250, maxBudget: 1500 },
	{ label: '$2,000', value: 2000, minBudget: 1500, maxBudget: 2000 },
	{ label: '$2,500', value: 2500, minBudget: 2000, maxBudget: 2500 },
	{ label: '$3,000', value: 3000, minBudget: 2500, maxBudget: 3000 },
	{ label: '$4,000', value: 4000, minBudget: 3500, maxBudget: 4000 },
	{ label: '$5,000', value: 5000, minBudget: 4500, maxBudget: 5000 },
	{ label: '$10,000', value: 10000, minBudget: 7000, maxBudget: 10000 },
	{ label: '$12,500', value: 12500, minBudget: 10000, maxBudget: 12500 },
	{ label: '$15,000', value: 15000, minBudget: 12500, maxBudget: 15000 },
];
